/**
 * 606 Meta5 AI Trading - Stat Card Component
 */
import React from 'react';
import { motion } from 'framer-motion';

const StatCard = ({ title, value, icon: Icon, color = '#d4af37', trend, suffix = '' }) => {
  const isPositive = trend > 0;
  const isNegative = trend < 0;
  
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="bg-white/[0.02] backdrop-blur-xl rounded-xl border border-white/10 p-4"
    >
      <div className="flex items-center justify-between mb-2">
        <span className="text-[#71717A] text-sm">{title}</span>
        {Icon && (
          <div 
            className="w-8 h-8 rounded-lg flex items-center justify-center"
            style={{ backgroundColor: `${color}20` }}
          >
            <Icon className="h-4 w-4" style={{ color }} />
          </div>
        )}
      </div>
      <div className="flex items-end gap-2">
        <span className="text-2xl font-bold text-white">
          {typeof value === 'number' ? value.toLocaleString() : value}
          {suffix}
        </span>
        {trend !== undefined && trend !== 0 && (
          <span className={`text-xs ${isPositive ? 'text-emerald-400' : isNegative ? 'text-red-400' : 'text-[#71717A]'}`}>
            {isPositive ? '+' : ''}{trend.toFixed(2)}%
          </span>
        )}
      </div>
    </motion.div>
  );
};

export default StatCard;
